/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Clearselection1Inputs */

const zh_common_clearselection1 = /** @type {(inputs: Common_Clearselection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消选择`)
};

const en_common_clearselection1 = /** @type {(inputs: Common_Clearselection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const es_common_clearselection1 = /** @type {(inputs: Common_Clearselection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Common_Clearselection1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_clearselection1 = /** @type {((inputs?: Common_Clearselection1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Clearselection1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_clearselection1(inputs)
	if (locale === "en") return en_common_clearselection1(inputs)
	return es_common_clearselection1(inputs)
});
export { common_clearselection1 as "common_clearSelection" }